import { getApi, putApi, postApi, deleteApi, getApiCSV } from 'apis';

const requestLoan = async (data: any) => {
	return await postApi('/loan', data);
};

const updateLoan = async (id: string, data: any) => {
	return await putApi(`/loan/update/${id}`, data);
};

const getLoanRequests = async (data: any) => {
	return await getApi('/loan', data);
};

const getLoanRequestDetails = async (id: any) => {
	return await getApi(`/loan/${id}`);
};

const updateLoanRequestStatus = async (id: string, data: any) => {
	return await putApi(`/loan/loanStatus/${id}`, data);
};

export const updateLoanRequest = async (id: string, data: any) => {
	return await putApi(`/loan/${id}`, data);
};

const deleteLoanRequest = async (id: any) => {
	return await deleteApi(`/loan/delete/${id}`);
};

const updateEffectiveDate = async (data: any) => {
	return await putApi(`/loan/creditLoan`, data);
};

const getLoanByEmployee = async (employeeId: string) => {
	return await getApi(`/loan/employee/${employeeId}`);
};

const getEmployeeDetailsForLoan = async (loanIds: string[]) => {
	return await postApi('/loan/employee-details', { loanIds });
};

const proceedToPaymentForFCB = async (data: any) => {
	return await postApi('/loan/initiate-payment', data);
};

const getBankDetailsForLoanDetails = async (data: { currency: string }) => {
	return await postApi('/loan/bank-details', data);
};

const downloadEmployeeLoanCsvWithTemplate = async (query:any) => {
	return await getApiCSV('/loan/all-loanEmployees-csv', query);
};

const getPaymentLogs = async (query: any) => {
	return await getApi('/loan/payment-logs', query);
};


export const loanRequestApi = {
	getLoanRequests,
	getLoanRequestDetails,
	deleteLoanRequest,
	updateEffectiveDate,
	requestLoan,
	updateLoan,
	updateLoanRequestStatus,
	getLoanByEmployee,
	getEmployeeDetailsForLoan,
	proceedToPaymentForFCB,
	getBankDetailsForLoanDetails,
	downloadEmployeeLoanCsvWithTemplate,
	getPaymentLogs,
};
